import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation, useQueryClient } from 'react-query';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function useDeleteApplicationExpense() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: async ({
      applicationID,
      expenseID,
    }: {
      applicationID: string;
      expenseID: string;
    }) =>
      await loan_application_api.deleteExpense(api)(applicationID, expenseID),

    onSettled: (_data, _error, variables) => {
      client.removeQueries(applicationKeys.expenses(variables.applicationID));
      client.removeQueries(
        applicationKeys.root({ applicationID: variables.applicationID }),
      );
    },
  });
}
